import React, { Component } from 'react'
import {connect} from "react-redux";
import {Field, reduxForm} from 'redux-form'
import UserAvatar from 'react-user-avatar'
import UploadAvatar from './UploadAvatar'
import ChangePassword from './ChangePassword'
import { updateUser } from '../../../actions/index'
import {renderCal, renderInput, renderCheckbox} from '../../forms/newcaso/Fields'

class User extends Component{
    constructor(props) {
        super(props);
        this.state = {
            showUpload: false,
            showPassword: false
        }
    }
    toggleModalUpload() {
        this.setState({
            showUpload: !this.state.showUpload
        })
    }
    toggleModalPassword() {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }
    componentWillUpdate(nextProps, nextState){
    }
    handleFormSubmit(data){
        this.props.updateUser(data, this.props.user.id)
    }
    renderForm() {
        const {handleSubmit} = this.props;
        return (
            <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                {this.state.status === "error" && this.renderError()}
                <div className="form-row">
                    <Field
                        name="num_colegiado"
                        col="col-md-6"
                        label="Número de colegiado"
                        component={renderInput.bind(this)}
                    />
                    <Field
                        name="phone"
                        col="col-md-6"
                        label="Teléfono"
                        component={renderInput.bind(this)}
                    />
                    <Field
                        name="name"
                        col="col-md-12"
                        label="Nombre"
                        component={renderInput.bind(this)}
                    />
                    <Field
                        name="email"
                        col="col-md-12"
                        label="Email"
                        component={renderInput.bind(this)}
                    />
                </div>
                <div className="form-actions text-right">
                    <button type="submit" className="btn btn-primary next">Cambiar mis datos de usuario &nbsp;<i
                        className="fa fa-edit"></i></button>
                </div>
            </form>
        )
    }
    render(){
        return(
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <h4 className="text-secondary">Imagen de usuario</h4>
                        <hr />
                        <UploadAvatar
                            userId={this.props.user.id}
                            toggler={this.toggleModalUpload.bind(this)}
                            show={this.state.showUpload}
                        />
                        <UserAvatar src={this.props.user.avatar} size="64" name={this.props.user.name || "-"} />
                        <button
                            onClick={ this.toggleModalUpload.bind(this) }
                            className="btn btn-outline-primary">
                            <i className="fa fa-refresh" />&nbsp;
                            Cambiar imagen de usuario
                        </button>
                    </div>
                    <div className="col-md-6">
                        <h4 className="text-secondary">Contraseña</h4>
                        <hr />
                        <div className="row">
                            <div className="col-md-2">
                                <i className="text-light fa fa-5x fa-shield"/>
                            </div>
                            <div className="col-md-10">
                                <button
                                    style={{marginTop:"18px"}}
                                    onClick={ this.toggleModalPassword.bind(this) }
                                    className="btn btn-outline-primary">
                                    <i className="fa fa-refresh" />&nbsp;
                                    Cambiar contraseña
                                </button>
                            </div>
                        </div>
                        <ChangePassword
                            userId={this.props.user.id}
                            toggler={this.toggleModalPassword.bind(this)}
                            show={this.state.showPassword}
                        />
                    </div>
                </div>
                <div>
                    <h4 className="mt-4 text-secondary">Datos de usuario</h4>
                    <hr />
                    {this.renderForm()}
                </div>
            </div>
        )
    }
}
const validate = (values) => {
    const msg_req = "Campo requerido";
    let errors = {};
    if (!values.name) {
        errors.name = msg_req;
    }
    if (!values.apellidos) {
        errors.apellidos = msg_req;
    }
    if (!values.phone || !/^[679]{1}[0-9]{8}$/i.test(values.phone)) {
        errors.phone = msg_req;
    }
    if (!values.num_colegiado || !/^\d+$/i.test(values.num_colegiado)) {
        errors.num_colegiado = msg_req;
    }
    if (!values.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = msg_req;
    }
    return errors;
}
const mapStateToProps = (state) => {
    return {
        initialValues: state.user
    }
}
User = reduxForm({
    form: 'editUSer',
    enableReinitialize: true,
    validate: validate
})(User);
export default User = connect(mapStateToProps, {updateUser})(User);


// WEBPACK FOOTER //
// ./resources/assets/js/components/settings/user/User.jsx